// Project template configuration
export const projectTemplates = {
    empty: {
        tracks: [
            {
                id: 1, name: 'Voice & Mic', type: 'audio', volume: 0.8, pan: 0,
                mute: false, solo: false, armed: false, color: '#EC4899',
                instrument: null, clips: []
            }
        ]
    },
    piano: {
        tracks: [
            {
                id: 1, name: 'Piano', type: 'midi', volume: 0.8, pan: 0,
                mute: false, solo: false, armed: false, color: '#3B82F6',
                instrument: 'piano', clips: []
            },
            {
                id: 2, name: 'Voice & Mic', type: 'audio', volume: 0.8, pan: 0,
                mute: false, solo: false, armed: false, color: '#EC4899',
                instrument: null, clips: []
            }
        ]
    },
    band: {
        tracks: [
            {
                id: 1, name: 'Drums', type: 'midi', volume: 0.9, pan: 0,
                mute: false, solo: false, armed: false, color: '#EF4444',
                instrument: 'drums', clips: []
            },
            {
                id: 2, name: 'Bass', type: 'midi', volume: 0.8, pan: -0.2,
                mute: false, solo: false, armed: false, color: '#10B981',
                instrument: 'bass', clips: []
            },
            {
                id: 3, name: 'Guitar', type: 'audio', volume: 0.7, pan: 0.3,
                mute: false, solo: false, armed: false, color: '#F59E0B',
                instrument: null, clips: []
            },
            {
                id: 4, name: 'Voice & Mic', type: 'audio', volume: 0.8, pan: 0,
                mute: false, solo: false, armed: false, color: '#EC4899',
                instrument: null, clips: []
            }
        ]
    },
    electronic: {
        tracks: [
            {
                id: 1, name: 'Kick', type: 'midi', volume: 0.9, pan: 0,
                mute: false, solo: false, armed: false, color: '#EF4444',
                instrument: 'drums', clips: []
            },
            {
                id: 2, name: 'Synth Lead', type: 'midi', volume: 0.7, pan: 0,
                mute: false, solo: false, armed: false, color: '#8B5CF6',
                instrument: 'synth', clips: []
            },
            {
                id: 3, name: 'Bass Synth', type: 'midi', volume: 0.8, pan: 0,
                mute: false, solo: false, armed: false, color: '#10B981',
                instrument: 'bass', clips: []
            },
            {
                id: 4, name: 'Voice & Mic', type: 'audio', volume: 0.8, pan: 0,
                mute: false, solo: false, armed: false, color: '#EC4899',
                instrument: null, clips: []
            }
        ]
    },
    hiphop: {
        tracks: [
            {
                id: 1, name: 'Drums', type: 'midi', volume: 0.9, pan: 0,
                mute: false, solo: false, armed: false, color: '#EF4444',
                instrument: 'drums', clips: []
            },
            {
                id: 2, name: '808 Bass', type: 'midi', volume: 0.8, pan: 0,
                mute: false, solo: false, armed: false, color: '#10B981',
                instrument: 'bass', clips: []
            },
            {
                id: 3, name: 'Voice & Mic', type: 'audio', volume: 0.8, pan: 0,
                mute: false, solo: false, armed: false, color: '#EC4899',
                instrument: null, clips: []
            }
        ]
    },
    acoustic: {
        tracks: [
            {
                id: 1, name: 'Acoustic Guitar', type: 'audio', volume: 0.8, pan: 0,
                mute: false, solo: false, armed: false, color: '#F59E0B',
                instrument: null, clips: []
            },
            {
                id: 2, name: 'Vocals', type: 'audio', volume: 0.7, pan: 0,
                mute: false, solo: false, armed: false, color: '#EC4899',
                instrument: null, clips: []
            },
            {
                id: 3, name: 'Voice & Mic', type: 'audio', volume: 0.8, pan: 0,
                mute: false, solo: false, armed: false, color: '#8B5CF6',
                instrument: null, clips: []
            }
        ]
    }
}; 